export default __webpack_public_path__ + "static/media/108.161ae390.webp";